'use strict';

/*global DEBUG */
/*global initialize*/
/*global isEmpty*/
/*global services*/

function varDump(obj, target) {
    var out = '';
    for(var i = 0; i < obj.length; i++) {
        out += i + ': ' + obj[i] + '\n';
    }
    if(isEmpty(target) || target === 'console') {
        console.log(out);
    } else
    if(target === 'body') {
        var pre = document.createElement('pre');
        pre.innertHtml = out;
        document.body.appendChild(pre);
    } else
    if(target === 'alert') {
        alert(out);
    }
}

function echo(str, target) {
    if(isEmpty(target) || target === 'console') {
        console.log(str);
    } else
    if(target === 'body') {
        var pre = document.createElement('pre');
        pre.innertHtml = str;
        document.body.appendChild(pre);
    } else
    if(target === 'alert') {
        alert(str);
    }
}

// odblokuje element
function unBlockElement(element) {
    element.removeClass('uiBlockerParent').find('.blocker').remove();
}

// zablokuje element prekryvnym divem
function blockElement(element) {
    unBlockElement(element);
    element.addClass('uiBlockerParent')
           .append('<div class="blocker">').find('.blocker').append($('<div class="loader" />').append('<span class="bar"></span><span class="bar"></span><span class="bar"></span>'));
}

function isArray(object) {
    if(Object.prototype.toString.call(object) === '[object Array]') {
        return true;
    }
    return false;
}

function removeDiak(str) {
  var withDiak = 'áäčďéěíĺľňóô öŕšťúů üýřžÁÄČĎÉĚÍĹĽŇÓÔ ÖŔŠŤÚŮ ÜÝŘŽ';
  var withOutdiak = 'aacdeeillnoo orstuu uyrzAACDEEILLNOO ORSTUU UYRZ';

  var newStr = '';
  for(var i = 0; i < str.length; i++) {
    if(withDiak.indexOf(str.charAt(i)) !== -1) {
      newStr += withOutdiak.charAt(withDiak.indexOf(str.charAt(i)));
    } else {
      newStr += str.charAt(i);
    }
  }
  return newStr;
}

function capitalize(s) {
    return s && s[0].toUpperCase() + s.slice(1);
}

function setDBCookie(name, value, async) {
    if(isEmpty(async)) {
        async = true;
    }

    $.ajax({
         url: services.get('configurations').param('DomainURL') + '?action=db-cookies&method=js_set_db_cookie',
         type: 'POST',
         data: { name: name, value: value },
         async: async,
         success: function (result) {
             if (result.isOk === false) {
                 echo('error');
             }
         },
    });
}

function getDBCookie(name) {
    var ret = null;
    $.ajax({
        url: services.get('configurations').param('DomainURL') + '?action=db-cookies&method=js_get_db_cookie',
        data: { name: name },
        async: false,
        success: function (res) {
            ret = res.data.value;
        }
    });
    return ret;
}

// uložení cookie
function setCookie(name, value) {
    setDBCookie(name, value);
}

// načtení cookie
function getCookie(name) {
    return getDBCookie(name);
}

function getObjectName(object) {
   var funcNameRegex = /function (.{1,})\(/;
   var results = (funcNameRegex).exec((object).constructor.toString());
   return (results && results.length > 1) ? results[1] : '';
}

function isTouchDevice() {
  return 'ontouchstart' in window || 'onmsgesturechange' in window; // works on most browsers || works on ie10
}

function doBackstretch() {
    jQuery('.doBackstretch:not(.hasBackstretch)').each(function () {
        jQuery(this).addClass('hasBackstretch');
        jQuery(this).backstretch(jQuery(this).find('img').attr('src'));
        jQuery(this).find('img').css('display', 'none');
    });
}

function updateTextareas(textareaList) {
    textareaList.each(function () {
        jQuery(this).height(0).height(jQuery(this).prop('scrollHeight'));
    });
}

function getPosition(el) {
  var xPos = 0;
  var yPos = 0;

  while(el) {
    if(el.tagName === 'BODY') {
      // deal with browser quirks with body/window/document and page scroll
      var xScroll = el.scrollLeft || document.documentElement.scrollLeft;
      var yScroll = el.scrollTop || document.documentElement.scrollTop;

      xPos += (el.offsetLeft - xScroll + el.clientLeft);
      yPos += (el.offsetTop - yScroll + el.clientTop);
    } else {
      // for all other non-BODY elements
      xPos += (el.offsetLeft - el.scrollLeft + el.clientLeft);
      yPos += (el.offsetTop - el.scrollTop + el.clientTop);
    }

    el = el.offsetParent;
  }

  return {
    x: xPos,
    y: yPos
  };
}

function addRow($row, rowClass, initializeFn) {
    initializeFn = initializeFn || ('initialize' in window ? window.initialize : null);

    var $original = $row.closest(rowClass);
    $original.find('.date-picker').datepicker('destroy');

    var $clon = $original.clone(true);
    var $formElm = $clon.find('input, select, textarea');

    $formElm.each(function () {
        if(!isEmpty($(this).data('name'))) {
            $(this).attr('name', $(this).data('name').replace('key', $(rowClass).length));
        }
    });

    $clon.find('input:not(:checkbox), select, textarea').not('.input--do-not-replace').each(function () {
        $(this).val('');
    });

    $clon.find(':checkbox').attr('checked', true);
    if($clon.find('select.chosenSelect').length) {
        $clon.find('select.chosenSelect').each(function () {
            $(this).next('.chzn-container').remove();
            $(this).css({ display: 'inline-block' }).removeClass('chzn-done').removeAttr('id').removeData('chosen').val(0);
        });
    }

    $clon.insertAfter($original);
    if (initializeFn) {
        initializeFn($original);
        initializeFn($clon);
    }

    return $clon;
}

function removeRow($row, rowClass) {
    $row.closest(rowClass).remove();
}

function replaceAttrKey($elem, attr, nthAr, key) {
    var nameValue = $elem.attr(attr);

    if(!isEmpty(nameValue)) {
        var nth = 0;
        nameValue = nameValue.replace(/\[([0-9]|[a-z]|[A-Z]|")*\]/g, function (match, i, original) {
            nth++;
            return (nth === (nthAr)) ? '[' + key + ']' : match;
        });
        $elem.attr(attr, nameValue);
    }
}

function checkRowButtons(buttonClass, $wrapper) {
    if(typeof $wrapper === 'string') {
        $wrapper = $($wrapper);
    }
    if($wrapper.find(buttonClass).length > 1) {
        $wrapper.find(buttonClass).show();
    } else {
        $wrapper.find(buttonClass).hide();
    }
}

function guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}

function unRegisterDocumentEvent(event) {
    $(document).off(event);
}

function registerDocumentEvent(event, handler) {
    $(document).on(event, handler);
}

function createObjectCallBack(object, func, customParams) {
  return function () {
      if (customParams) {
        object[func](customParams, Array.prototype.slice.call(arguments));
      } else {
        object[func](Array.prototype.slice.call(arguments));
      }
  };
}

function addZero(i) {
  if (i < 10) {
    i = '0' + i;
  }

  return i;
}

function serializeContainer($container) {
    return $container.find('input, select, textarea').serialize();
}

function sprintf(format) {
  for (var i = 1; i < arguments.length; i++) {
    format = format.replace(/%s/, arguments[i]);
  }

  return format;
}
